export default "__VITE_ASSET__CiTnD9H2__"